import { ReactNode } from 'react';

import { SharedProps } from '../types';
import Container from '../UI/Container';
import Layout from '../UI/Layout';
import { CharitySettingsLayout } from './CharitySettingsLayout';
import EditIntegrationsForm, { EditIntegrationsFormProps } from './EditIntegrationsForm';

export interface IntegrationsPageProps extends SharedProps {
  charity: EditIntegrationsFormProps['charity'];
}

export default function IntegrationsPage({
  charity,
}: IntegrationsPageProps) {
  return (
    <Container size="md" className="space-y-6">
      <EditIntegrationsForm charity={charity} />
    </Container>
  );
}

IntegrationsPage.layout = (page: ReactNode) => <Layout><CharitySettingsLayout>{page}</CharitySettingsLayout></Layout>;

